import React, { useEffect, useState } from 'react';
import { Box, Typography, Link, Table, TableHead, TableBody, TableRow, TableCell, Paper } from '@mui/material';
import axiosInstance from '../axiosConfig';
import './InfoCenter.css';
import API_URL from '../config';

const InfoCenter = () => {
  const [prices, setPrices] = useState({
    editions: [],
    pages: [],
    data: {}
  });  

  useEffect(() => {
    const fetchPrices = async () => {
      const token = localStorage.getItem('authToken');
      try {
        const response = await axiosInstance.get(
          '/prices/all',
          { headers: { Authorization: `${token}` } }
        );
        const pricesData = response.data.prices;
  
        // Extrahiere alle einzigartigen Seitenzahlen für die Kopfzeile
        const uniquePages = new Set();
        const formattedPrices = {};
  
        Object.entries(pricesData).forEach(([edition, priceList]) => {
          if (Array.isArray(priceList)) {
            formattedPrices[edition] = {}; // Initialisiere leere Map für jede Auflagenzahl
  
            priceList.forEach(priceEntry => {
              if (priceEntry.pages && priceEntry.price) {
                uniquePages.add(priceEntry.pages);
                formattedPrices[edition][priceEntry.pages] = priceEntry.price;
              }
            });
          }
        });
  
        setPrices({
          editions: Object.keys(formattedPrices).map(Number).sort((a, b) => a - b),
          pages: [...uniquePages].sort((a, b) => a - b),
          data: formattedPrices
        });
      } catch (error) {
        console.error('Fehler beim Abrufen der Preise:', error);
      }
    };
  
    fetchPrices();
  }, []);  

  return (
    <Box sx={{ padding: '2rem', maxWidth: '800px', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <Box sx={{ border: '1px solid #ccc', borderRadius: '8px', mt: 1.4 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '50px',
            borderBottom: '2px solid #e0e0e0',
            backgroundColor: '#f9f9f9',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: '#333',
              letterSpacing: '0.5px'
            }}
          >
            Informationszentrum
          </Typography>
        </Box>
        <Box sx={{ padding: '2rem'}}>
        {/* <Typography variant="h5" gutterBottom>
          Downloads
        </Typography>
        <Typography variant="body1" gutterBottom>
        Hier finden Sie die Benutzungsanleitungen für das gedruckte Schullogbuch. Klicken Sie auf eine der nachfolgenden Links, um sie herunterzuladen. Wählen Sie diejenige aus, die Ihrer primären Kategorie im Schullogbuch-Konfigurator entspricht.
        </Typography>
        <ul>
          <li>
            <Typography variant="body1">
              <Link href={`${API_URL}/uploads/manuals/schuelerorientiert.pdf`} target="_blank" download>
                Benutzungsanleitung "Schülerorientiert"
              </Link>
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <Link href={`${API_URL}/uploads/manuals/prozessorientiert.pdf`} target="_blank" download>
                Benutzungsanleitung "Prozess-/Projektorientiert"
              </Link>
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <Link href={`${API_URL}/uploads/manuals/schulorientiert.pdf`} target="_blank" download>
                Benutzungsanleitung "Schulorientiert"
              </Link>
            </Typography>
          </li>
        </ul> */}
        <Box>
          <Typography variant="h5" gutterBottom>
            Preisübersicht
          </Typography>
          <Typography variant="body1" gutterBottom>
            Transparenz ist uns wichtig, daher können Sie hier die aktuelle Preisübersicht für den Druck Ihrer Schullogbücher einsehen.
          </Typography>
          <Typography sx={{ mt: '2rem' }} variant="body1" gutterBottom>
            In der folgenden Tabelle finden Sie den Stückpreis eines Schullogbuchs, abhängig von der Seitenzahl des Buchs und der Anzahl der bestellten Exemplare.
          </Typography>
          <Paper sx={{ overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell color="primary" sx={{ position: 'relative', width: '100px', textAlign: 'center', backgroundColor: "primary.light", color: "#fff" }} className="corner-header">
                  <Typography sx={{ fontWeight: "bold" }} className="corner-text exemplare">Exemplare</Typography>
                  <Typography sx={{ fontWeight: "bold" }} className="corner-text seiten">Seiten</Typography>
                </TableCell>
                {prices.pages.length > 0 &&
                  prices.pages.map((page) => (
                    <TableCell color="primary" key={page} sx={{ fontSize: '0.85rem', padding: '4px 8px', width: 'auto', textAlign: 'center', backgroundColor: "primary.light", color: "#fff" }}>
                      <strong>{page}</strong>
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {prices.editions.length > 0 && prices.editions.map((edition, index) => (
                <TableRow
                  key={edition}
                  sx={{ backgroundColor: index % 2 === 1 ? "#bde1ff" : "#ffffff" }}
                >
                  <TableCell color="primary" sx={{ textAlign: 'center', padding: '0px', minWidth: '50px', backgroundColor: "primary.light", color: "#fff", fontWeight: "bold" }} className="exemplare-cell">
                    {edition}
                  </TableCell>
                  {prices.pages.map((page) => (
                    <TableCell key={page} className="table-cell">
                      {prices.data[edition] && prices.data[edition][page] 
                        ? `${prices.data[edition][page].toFixed(2)}\u00A0€` 
                        : "-"}
                    </TableCell>                
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          </Paper>
        </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default InfoCenter;
